import React, { useState } from 'react';
import { CheckIcon, FileTextIcon } from 'lucide-react';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };
  return <section className="py-20 lg:py-28 bg-tlfc-dark" data-id="element-355">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-356">
        <div className="max-w-3xl mx-auto text-center" data-id="element-357">
          {/* Lead Magnet Badge */}
          <div className="reveal inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-white/80 text-sm mb-8" data-id="element-358">
            <FileTextIcon className="w-4 h-4" aria-hidden="true" data-id="element-359" />
            Free: Property Settlement Checklist
          </div>

          {/* Header */}
          <h2 className="reveal font-serif text-3xl md:text-4xl text-tlfc-white" data-id="element-360">
            Stay informed, stay ahead
          </h2>
          <p className="reveal reveal-delay-1 mt-4 text-white/60 text-lg" data-id="element-361">
            Get practical legal insights delivered to your inbox. Plus, receive
            our free Property Settlement Checklist when you subscribe.
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="reveal reveal-delay-2 mt-10" data-id="element-362">
            <div className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto" data-id="element-363">
              <input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} className="flex-1 bg-white/10 border border-white/20 rounded-lg px-5 py-4 text-white placeholder:text-white/40 focus:border-tlfc-gold focus:outline-none transition-colors" aria-label="Email address" required data-id="element-364" />
              <button type="submit" className="px-8 py-4 bg-tlfc-gold text-white font-medium rounded-lg hover:bg-tlfc-gold-light transition-colors shadow-gold whitespace-nowrap" data-id="element-365">
                Get the Checklist
              </button>
            </div>

            {/* Trust indicators */}
            <div className="flex flex-wrap items-center justify-center gap-6 mt-6 text-sm text-white/40" data-id="element-366">
              <span className="inline-flex items-center gap-2" data-id="element-367">
                <CheckIcon className="w-4 h-4 text-tlfc-gold/70" aria-hidden="true" data-id="element-368" />
                No spam, ever
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-369">
                <CheckIcon className="w-4 h-4 text-tlfc-gold/70" aria-hidden="true" data-id="element-370" />
                Unsubscribe anytime
              </span>
            </div>
          </form>
        </div>
      </div>
    </section>;
}